import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs/Observable";
import { ActivatedRoute } from "@angular/router";
import { SharedService } from "./../../shared/shared.service";
import { AdminDevoteeService } from './../services/admin-devotee.service';
import { PrasadOrderView } from "./../../prasad-order/prasad-order";
import { PagingGridData } from "./../models/paging-grid-data";
import { PoByPaymentMode } from "./../models/po-by-payment-mode";
import { DevoteePrasadOrderVM } from "./../models/devotee-prasad-order-vm";
import { BookPujaVidhiRequest } from '../../prasad-order/book-puja-vidhi-request';

@Injectable()
export class AdminPrasadOrderService {

  constructor(private http: HttpClient
    , private sharedService: SharedService) { }


  ServiceUrl: string = SharedService.BaseServiceUrl + "AdminPrasadOrder";

  mobileServiceUrl: string = SharedService.BaseServiceUrl + "admin";

  // For Admin Authentication
  httpOptions = {
    headers: new HttpHeaders({
      'Authorization': 'Basic ' + this.sharedService.getAdminTokenAtLocStorage()
    })
  };


  public save(prasadOrder: BookPujaVidhiRequest) {

    let saveUrl=SharedService.BaseServiceUrl+ "book/puja/vidhis";
    return this.http.post<string>(saveUrl, prasadOrder);
  }

  public updateOrder(updateOrderRequest: any): Observable<string> {
    let updateUrl = this.mobileServiceUrl + "/update/order";
    return this.http.post<string>(updateUrl, updateOrderRequest);
  }

  public poDispatch(prasadOrder: PrasadOrderView) {
    let url = this.ServiceUrl + "/PODispatch";
    return this.http.post<string>(url, prasadOrder, this.httpOptions);
  }

  public prasadOrderSummaryReport(searchGridEntity: any): Observable<any> {

    let params = new HttpParams();
    for (let key in searchGridEntity) {
      if (searchGridEntity.hasOwnProperty(key) && searchGridEntity[key] !== null) {
        params = params.set(key, searchGridEntity[key]);
      }
    }

    let urlWithQueryString = this.mobileServiceUrl + "/orders/summary?" + params.toString();
    return this.http.get<any>(urlWithQueryString);
  }

  public prasadDispatchSendSMS(searchGridEntity: any): Observable<string> {
    let searchUrl = this.ServiceUrl + "/PrasadDispatchSendSMS";
    return this.http.post<string>(searchUrl, searchGridEntity, this.httpOptions);
  }

  public GetPODispatchList(searchGridEntity: any = {}): Observable<DevoteePrasadOrderVM[]> {
    let url = this.ServiceUrl + "/GetPODispatchList";
    return this.http.post<DevoteePrasadOrderVM[]>(url, searchGridEntity, this.httpOptions);
  }

  public GetPostOfficeParcelBooking(dispatchDate: Date): Observable<DevoteePrasadOrderVM[]> {
    let url = this.ServiceUrl + "/GetPostOfficeParcelBooking/" + dispatchDate;
    return this.http.get<DevoteePrasadOrderVM[]>(url, this.httpOptions);
  }

  public getbyPONo(PujaVidhDetailId: number): Observable<any> {
    var searchEntity = { PrasadOrderPujaVidhiId: PujaVidhDetailId };
    return this.search(searchEntity);
  }

  public getPrasadOrderDetails(orderId: number): Observable<any> {
    let getUrl = SharedService.BaseServiceUrl + "order/details/" + orderId;
    return this.http.get<any>(getUrl);
  }

  public search(searchGridEntity: any): Observable<any> {

    let params = new HttpParams();
    for (let key in searchGridEntity) {
      if (searchGridEntity.hasOwnProperty(key) && searchGridEntity[key] !== null) {
        params = params.set(key, searchGridEntity[key]);
      }
    }

    let searchUrlWithQueryString = this.mobileServiceUrl + "/orders?" + params.toString();

    return this.http.get<any>(searchUrlWithQueryString);
  }

  public searchPerformPuja(poPerformPujaSearch: any): Observable<PagingGridData> {
    let url = this.ServiceUrl + "/SearchPerformPuja/";

    return this.http.post<PagingGridData>(url, poPerformPujaSearch, this.httpOptions,);
  }

  public pujaPerformed(PujaOrderVidhiDetailIds: number[]): Observable<string> {
    let url = this.mobileServiceUrl + "/update/order/pujaperform/";
    var pujaPerformedObject = { "PujaVidhiIds": PujaOrderVidhiDetailIds };
    return this.http.post<string>(url, pujaPerformedObject);
  }

  public paymentDone(selOrders: number[]): Observable<string> {

    let url = this.mobileServiceUrl + "/update/order/paymentdone/"
    var paymentDoneObject = { "PrasadOrderIds": selOrders };
    return this.http.post<string>(url, paymentDoneObject);
  }

  public prasadDispatch(selOrders: number[]): Observable<string> {
    let url = this.mobileServiceUrl + "/update/order/dispatch/"
    var paymentDoneObject = { "PrasadOrderIds": selOrders };
    return this.http.post<string>(url, paymentDoneObject);
  }

  public updateDispatchedOrders(updateEntity: any): Observable<any> {
    let dispatchUrl = this.mobileServiceUrl + "/prasadorder/dispatch/";
  
    return this.http.post<any>(dispatchUrl, updateEntity);
  }

  public GetPOByPaymentMode(): Observable<any> {
    let searchUrl = this.ServiceUrl + '/GetPOByPaymentMode';
    return this.http.get<PoByPaymentMode>(searchUrl, this.httpOptions);
  }

  public deleteOrder(id: number): Observable<any> {
    let url = this.mobileServiceUrl + "/order/delete/";
    let deleteObject = { "PrasadOrderId": id };
    return this.http.post<any>(url, deleteObject);
  }




}



// WEBPACK FOOTER //
// ./src/app/admin/services/admin-prasad-order.service.ts